import { IconCheck } from '@tabler/icons-react';
import { cn } from '@/lib/utils';
import { useTranslation } from '../../../i18n/hooks/useTranslation';
import { PRESETS } from '../rateChartConfig';
import { PresetThumb } from '../RateChartThumbs';
import { tileCls } from '@/components/common/EditorFields';

/** The ready-made templates — picking one sets colour, layout, text size and columns at once. */
export default function TemplatePanel({ currentId, onPick }) {
    const { t } = useTranslation();
    return (
        <div className="grid grid-cols-2 gap-3">
            {PRESETS.map((p) => {
                const on = currentId === p.id;
                return (
                    <button
                        key={p.id}
                        type="button"
                        onClick={() => onPick(p)}
                        aria-pressed={on}
                        className={cn('relative text-left rounded-xl border-2 p-2 transition-colors', tileCls(on))}
                    >
                        <PresetThumb preset={p} />
                        <div className="px-0.5 pt-2 pb-0.5">
                            <div className={cn('text-[13px] font-semibold leading-tight', on ? 'text-primary' : 'text-zinc-800 dark:text-zinc-100')}>{t(`rateChart.presets.${p.id}.name`)}</div>
                            <div className="text-[11px] text-zinc-500 dark:text-zinc-400 leading-snug">{t(`rateChart.presets.${p.id}.sub`)}</div>
                        </div>
                        {on && (
                            <span className="absolute top-3.5 right-3.5 w-6 h-6 rounded-full bg-primary text-white flex items-center justify-center shadow">
                                <IconCheck size={14} stroke={3} />
                            </span>
                        )}
                    </button>
                );
            })}
        </div>
    );
}
